import type { OdooTask } from '@/types/odoo';
import { isFeestdagMarker, isVerlofTask } from '@/utils/planning';

/**
 * Who sees which installers on /planning (work item
 * administratie-volledige-planning). `administratie` on its own sees only our
 * own employees; a user who also holds one of these roles sees the whole
 * planning, subcontractors included (Igor, 2026-10-26: "general rule").
 * The EasyKit roles are not here: their planning is a different one.
 */
export const FULL_PLANNING_ROLES = ['admin', 'projectleider', 'oplijster', 'warehouse'] as const;

/** True when the planning must show only our own employees. Takes the auth
 *  store's `hasRole`, so the admin role override keeps working. */
export function planningEmployeesOnly(hasRole: (role: string) => boolean): boolean {
  return hasRole('administratie') && !FULL_PLANNING_ROLES.some((role) => hasRole(role));
}

/** The installer rows, without anyone who is not known as an employee. */
export function filterEmployeeUserMap(userMap: Map<number, string>, employeeMap: Map<number, boolean>): Map<number, string> {
  const filtered = new Map<number, string>();
  for (const [id, name] of userMap) {
    if (employeeMap.get(id)) filtered.set(id, name);
  }
  return filtered;
}

/** Tasks with at least one employee installer; feestdag markers and verlof
 *  always stay, they are structural. */
export function filterEmployeeTasks(tasks: OdooTask[], employeeMap: Map<number, boolean>): OdooTask[] {
  return tasks.filter((task) => {
    if (isFeestdagMarker(task) || isVerlofTask(task)) return true;
    const installers = task.x_studio_installateur || [];
    return installers.some((instId) => employeeMap.get(instId));
  });
}
